"use client";

import styled from "styled-components";
import Sec01Bg from "/public/assets/images/company/overview/sec01-bg.png"
import Sec02Item01 from "/public/assets/images/company/overview/sec02-1.png"
import Sec02Item02 from "/public/assets/images/company/overview/sec02-2.png"
import Sec02Item03 from "/public/assets/images/company/overview/sec02-3.png"
import Sec02Item04 from "/public/assets/images/company/overview/sec02-4.png"

import Sec03Item01 from "/public/assets/images/company/overview/sec03-1.png"
import Sec03Item02 from "/public/assets/images/company/overview/sec03-2.png"
import Sec03Item03 from "/public/assets/images/company/overview/sec03-3.png"
import Sec03Item04 from "/public/assets/images/company/overview/sec03-4.png"
import Sec03Item05 from "/public/assets/images/company/overview/sec03-5.png"
import Sec03Item06 from "/public/assets/images/company/overview/sec03-6.png"

import Sec04Item01 from "/public/assets/images/company/overview/sec04-1.png"
import Sec04Item02 from "/public/assets/images/company/overview/sec04-2.png"
import Sec04Item03 from "/public/assets/images/company/overview/sec04-3.png"
import Sec04Item04 from "/public/assets/images/company/overview/sec04-4.png"
import Sec04Item05 from "/public/assets/images/company/overview/sec04-5.png"

import Sec05Item01 from "/public/assets/images/company/overview/sec05-badge01.png"
import Sec05Item02 from "/public/assets/images/company/overview/sec05-badge02.png"
import Sec05Item03 from "/public/assets/images/company/overview/sec05-badge03.png"
import Sec05Item04 from "/public/assets/images/company/overview/sec05-badge04.png"

import Sec05ItemBg from "/public/assets/images/company/overview/sec05-item.png"
import Sec05ItemBackBg from "/public/assets/images/company/overview/sec05-item-back.png"
import {SIZES} from "@/components/constants";
import {useContext, useEffect, useRef} from "react";
import {LayoutContext} from "@/app/ClientRootHomepage";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {getScroller, refreshOnAssetsReady, setupLenyStyle} from "@/app/homepage/utils";
import {useMediaQuery} from "react-responsive";

gsap.config({ force3D: false });
const Overview = () => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });

    const { rootRef } = useContext(LayoutContext);
    const wrapRef = useRef(null);

    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;

        const scroller = getScroller(rootRef);
        const contentEl =
            (scroller && scroller.querySelector && scroller.querySelector(".root")) ||
            (scroller && scroller.firstElementChild) ||
            scroller;

        const { cleanup } = setupLenyStyle({ wrap, scroller, contentEl });
        const sec01Desc = wrap.querySelector(".content-wrap.sec01 .sec01-desc");
        if (sec01Desc) {
            gsap.set(sec01Desc, { opacity: 0, y: 30 });
            gsap.to(sec01Desc, {
                opacity: 1,
                y: 0,
                duration: 0.7,
                ease: "power2.out",
                delay: 0.1,
                force3D: false,
            });
        }
        const contentSections = Array.from(wrap.querySelectorAll(".section-content"));
        const triggers = [];
        const tweenItems = [];

        contentSections.forEach((item) => {
            gsap.set(item, { opacity: 0, y: 30, willChange: "transform, opacity" });
            const tweenGsap = gsap.to(item, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power2.out",
                paused: true,
                force3D: false,
            });
            const scrollGsap = ScrollTrigger.create({
                trigger: item,
                start: "top 80%",
                end: "top 45%",
                scroller,
                toggleActions: "play none none reverse",
                onEnter: () => tweenGsap.play(),
                onEnterBack: () => tweenGsap.play(),
                onLeaveBack: () => tweenGsap.reverse(),
            });
            tweenItems.push(tweenGsap);
            triggers.push(scrollGsap);
        });
        const sec01 = wrap.querySelector(".content-wrap.sec01");
        const sec01BgBox = wrap.querySelector(".content-wrap.sec01 .sec01-bg");
        const sec01BgImg = sec01BgBox && sec01BgBox.querySelector("img");
        let parallaxTween = null;

        const buildParallax = () => {
            if (!sec01BgBox || !sec01BgImg) return;
            const boxHeight = sec01BgBox.clientHeight;
            const imgHeight = sec01BgImg.getBoundingClientRect().height;
            const rangeHeight = Math.max(0, imgHeight - boxHeight);
            if (parallaxTween) {
                parallaxTween.scrollTrigger && parallaxTween.scrollTrigger.kill();
                parallaxTween.kill();
                parallaxTween = null;
            }
            parallaxTween = gsap.fromTo(
                sec01BgImg,
                { y: -rangeHeight / 2, willChange: "transform" },
                {
                    y: rangeHeight / 2,
                    ease: "none",
                    scrollTrigger: {
                        trigger: sec01,
                        start: "top bottom",
                        end: "bottom top",
                        scroller,
                        scrub: 0.6,
                    },
                }
            );
        };

        const offAssets = refreshOnAssetsReady(wrap, buildParallax);
        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);
        return () => {
            triggers.forEach((st) => st.kill());
            tweenItems.forEach((tw) => tw.kill());
            if (parallaxTween) {
                parallaxTween.scrollTrigger && parallaxTween.scrollTrigger.kill();
                parallaxTween.kill();
            }
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef, isTablet]);




    return(
        <OverviewWrap ref={wrapRef}>
            <div className={"content-wrap sec01"}>
                <div className={"section-content"}>
                    <div className={"tit "}>
                        {
                            !isTablet ?
                                <>국민의 건강을 지키는<br/> 바이오 유통의 첫 번째 이름, 웅비메디텍</>
                                :
                                <>국민의 건강을 지키는<br/> 바이오 유통의 첫 번째 이름,<br/>웅비메디텍</>
                        }
                    </div>
                    <div className={"sec01-desc"}>
                        {
                            !isTablet ?
                                <>30년 동안 한결같이 가족과 국민의 건강을 지키겠다는 사명을 실천해왔습니다.<br/> 기술과 신뢰, 그리고 사람 중심 경영으로 더 큰 내일을 준비합니다.</>
                                :
                                <>30년 동안 한결같이 가족과 국민의 건강을<br/>지키겠다는 사명을 실천해왔습니다.<br/> 기술과 신뢰, 그리고 사람 중심 경영으로<br/>더 큰 내일을
                                    준비합니다.</>
                        }
                    </div>
                </div>
                <div className={"sec01-bg"}><img src={Sec01Bg?.src} alt={"한눈에보기 이미지"}/></div>
            </div>
            <div className={"content-wrap sec02 section-content"}>
                <div className={"tit"}>
                    {
                        !isTablet ?
                            <>정직한 유통, 끊임없는 혁신으로 사람과 생명을 연결합니다</>
                            :
                            <>정직한 유통, 끊임없는 혁신으로<br/>사람과 생명을 연결합니다</>
                    }
                </div>
                <div className={"sec02-desc"}>
                    웅비메디텍은 <span className={"bold"}>“좋은 회사에서 훌륭한 회사로”라는 비전</span>을 바탕으로 정직·성실, 고객만족, 가치창출, 행복추구, 현장실행,
                    성과실현이라는 <span className={"bold"}>6대 핵심가치를 실천</span>하고 있습니다.<br/><br/>
                    유통 이상의 가치를 만들어내기 위해 직원 역량 강화, 지속가능한 조직문화, 동반성장에 투자하고 있으며신약 개발과 제조로의 도약 또한 준비하고 있습니다.<br/>
                    연구 및 진단의 질병-유전자 융복합 방향에 맞추어 <span className={"bold"}>최신화된 신약 및 치료법 연구에 초점을 맞춘 효익적 학술 상담을 드리기 위해 노력하겠습니다.</span>
                </div>
                <div className={"sec02-cont"}>
                    <div className={"sec02-item inner01"}>
                        <div className={"item-text-wrap item01"}>
                            <div className={"item-tit"}>함께하는 사람들</div>
                            <div className={"item-desc"}>약 50-55명</div>
                        </div>
                        <div className={"item-img-wrap item01"}><img src={Sec02Item01?.src} alt={"함께하는 사람들"}/></div>
                    </div>
                    <div className={"center"}>
                        <div className={"sec02-item"}>
                            <div className={"item-text-wrap item02"}>
                                <div className={"item-tit"}>성장의 발자취</div>
                                <div className={"item-desc"}>연매출 400억원</div>
                            </div>
                            <div className={"item-img-wrap item02"}><img src={Sec02Item02?.src} alt={"성장의 발자취"}/></div>
                        </div>
                        <div className={"sec02-item"}>
                            <div className={"item-text-wrap"}>
                                <div className={"item-tit"}>믿고 함께하는 파트너</div>
                                <div className={"item-desc"}>
                                    대학병원<br/>
                                    임상연구소<br/>
                                    바이오 벤처<br/>
                                    제약사 등 활발한 거래
                                </div>
                            </div>
                            <div className={"item-img-wrap item03"}><img src={Sec02Item03?.src} alt={"믿고 함께하는 파트너"}/></div>
                        </div>
                    </div>
                    <div className={"sec02-item inner02"}>
                        <div className={"item-text-wrap"}>
                            <div className={"item-tit"}>학술 및 기술지원</div>
                            <div className={"item-desc"}>
                                면역정량/세포재생<br/>
                                인체유사모델/EV솔루션<br/>
                                분자진단/유전자검사<br/>
                                NGS/Immuno-Oncology
                            </div>
                        </div>
                        <div className={"item-img-wrap item04"}><img src={Sec02Item04?.src} alt={"학술 및 기술지원"}/></div>
                    </div>
                </div>
            </div>
            <div className={"content-wrap section-content"}>
                <div className={"tit"}>
                    {
                        !isTablet ?
                        <>사람을 키우는 기업, 함께 성장하는 조직</>
                        :
                        <>사람을 키우는 기업,<br/>함께 성장하는 조직</>
                    }
                </div>
                <div className={"sec03-desc"}>
                    웅비메디텍은 인성과 전문성을 갖춘 인재를 바탕으로 지속 가능한 조직문화를 만들어가고 있습니다.<br/>
                    정기 교육과 문화 프로그램, 팀워크 기반의 상생 문화를 통해 직원과 회사가 함께 성장하고 있습니다.
                </div>
                <div className={"sec03-cont-wrap"}>

                    <div className={"sec03-cont-tit"}>Core Value</div>
                    <div className={"sec03-cont-inner"}>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item01?.src} alt={"Core Value item bg01"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Integrity</div>
                        </div>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item02?.src} alt={"Core Value item bg02"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Customer</div>
                        </div>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item03?.src} alt={"Core Value item bg03"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Innovation</div>
                        </div>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item04?.src} alt={"Core Value item bg04"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Happiness</div>
                        </div>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item05?.src} alt={"Core Value item bg05"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Execution</div>
                        </div>
                        <div className={"list"}>
                            <div className={"img-wrap"}>
                                <div className={"circle-inner"}>
                                    <img src={Sec03Item06?.src} alt={"Core Value item bg06"}/>
                                </div>
                            </div>
                            <div className={"sec03-item-info"}>Result</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"content-wrap section-content"}>
                <div className={"tit"}>
                    오가노이드 연구 전 과정을 아우르는 토탈 솔루션 제공
                </div>
                <div className={"sec04-desc"}>
                    웅비는 30년의 업력과 노하우를 최신 연구 트렌드와 접목하여,<br/>
                    기초적인 Immunoassay부터 qPCR Prep까지 오가노이드 모의실험 Workflow에 최적화된 제품과 서비스를 공급합니다.
                </div>
                <div className={"sec04-cont-wrap"}>
                    <div className={"list-wrap"}>
                        <div className={"item"}>
                            <div className={"img-item"}><img src={Sec04Item01?.src} alt={"오가노이드 연구 bg1"} /></div>
                            <div className={"desc-item"}>항원-항체 정량</div>
                        </div>
                        <div className={"item"}>
                            <div className={"img-item"}><img src={Sec04Item02?.src} alt={"오가노이드 연구 bg2"}/></div>
                            <div className={"desc-item"}>세포 재생/사멸 측정</div>
                        </div>
                        <div className={"item"}>
                            <div className={"img-item"}><img src={Sec04Item03?.src} alt={"오가노이드 연구 bg3"}/></div>
                            <div className={"desc-item"}>면역 및 줄기세포<br/>분리·증식</div>
                        </div>
                        <div className={"item"}>
                            <div className={"img-item"}><img src={Sec04Item04?.src} alt={"오가노이드 연구 bg4"}/></div>
                            <div className={"desc-item"}>질병 모델 모의 설계</div>
                        </div>
                        <div className={"item"}>
                            <div className={"img-item"}><img src={Sec04Item05?.src} alt={"오가노이드 연구 bg5"}/></div>
                            <div className={"desc-item"}>분자/유전자진단 및<br/>NGS 검사</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"content-wrap sec05 section-content"}>
                <div className={"tit"}>
                    {
                        !isTablet ?
                            <>유통을 넘어, 생명과 기술을 아우르는 바이오 혁신 기업으로</>
                            :
                            <>유통을 넘어,<br/>생명과 기술을 아우르는<br/>바이오 혁신 기업으로</>
                    }
                </div>
                <div className={"sec05-desc"}>
                    {
                        !isTablet ?
                        <>웅비메디텍은 단순 유통을 넘어<br/>신약 개발, 제조까지 도전하는 토탈 바이오 솔루션 기업으로 도약하고 있습니다.</>
                        :
                        <>웅비메디텍은 단순 유통을 넘어 신약 개발,<br/>제조까지 도전하는 토탈<br/>바이오 솔루션 기업으로<br/>도약하고 있습니다.</>
                    }

                </div>
                <div className={"sec05-cont-wrap"}>
                    <div className={"sec05-info-wrap"}>
                        <div className={"sec05-info-title"}>
                            {
                                !isTablet ?
                                    <>2030년, 유통을 넘어 바이오 산업의 혁신 기업으로!</>
                                    :
                                    <>2030년, 유통을 넘어<br/>바이오 산업의 혁신 기업으로!</>
                            }

                        </div>
                        <div className={"sec05-info-item"}>
                            <div className={"item-wrap"}>
                                <div className={"list"}>
                                    <div className={"list-icon"}><img src={Sec05Item01?.src} alt={"바이오 혁신 기업 아이콘1"}/></div>
                                    <div className={"list-desc"}>연매출1,000억 원</div>
                                </div>
                                <div className={"list item02"}>
                                    <div className={"list-icon"}><img src={Sec05Item02?.src} alt={"바이오 혁신 기업 아이콘2"}/></div>
                                    <div className={"list-desc"}>상장 계획 코스닥 진출 예정</div>
                                </div>
                            </div>
                            <div className={"item-wrap"}>
                                <div className={"list item03"}>
                                    <div className={"list-icon"}><img src={Sec05Item03?.src} alt={"바이오 혁신 기업 아이콘3"}/></div>
                                    <div className={"list-desc"}>계열사6개 설립 목표</div>
                                </div>
                                <div className={"list item04"}>
                                    <div className={"list-icon"}><img src={Sec05Item04?.src} alt={"바이오 혁신 기업 아이콘4"}/></div>
                                    <div className={"list-desc"}>시설자사 사옥 건립</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"sec05-img-wrap"}>
                        <div className={"item-img"}><img src={Sec05ItemBg?.src} alt={"바이오 혁신 기업 bg"} /></div>
                        <div className={"back-item-img"}><img src={Sec05ItemBackBg?.src} alt={"바이오 혁신 기업 뒷 bg"}/></div>
                    </div>
                </div>
            </div>
        </OverviewWrap>
    )
}
const OverviewWrap = styled.div`
    padding: 160px 0 105px;
    .content-wrap{
        padding: 0 114px;
        &.sec01{
            padding: 0;
            text-align: center;
        }
        &.sec05{
            padding: 0;
            .tit{
                padding: 0 114px;
            }
        }
        & + .content-wrap{
            margin-top: 160px;
        }
        .tit{
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            letter-spacing: -0.02em;
            color: #4939B1;
            .char { display:inline-block;}
            .char.is-space {
                width: 0.3em; /* 필요하면 0.4em~0.6em 사이로 조절 */
            }
        }
        .sec01-desc{
            margin-top: 40px;
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #333333;
        }
        .sec01-bg{
            margin-top: 80px;
            width: 100%;
            height: clamp(100px, 20.5vw, 350px);
            overflow: hidden;
            position: relative;
            img { display:block; width:100%; will-change: transform; }
        }
        .sec02-desc{
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #23203B;
            margin-top: 60px;
        }
        .sec02-cont{
            margin-top: 60px;
            padding: 45px 0 40px;
            background: #F2F2F2;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 24px;
            .center{
                .sec02-item{
                    & + .sec02-item{
                        margin-top: 24px;
                    }
                }
            }
            .sec02-item{
                display: flex;
                padding: 32px;
                flex-shrink: 0;
                box-sizing: border-box;
                width: 340px;
                height: 220px;
                background: #FFFFFF;
                box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1), 2px 2px 2px rgba(0, 0, 0, 0.1);
                border-radius: 20px;
                .item-img-wrap{
                    display: flex;
                    align-items: end;
                    &.item01{
                        width: 145px;
                    }
                    &.item02{
                        width: 175px;
                    }
                    &.item03{
                        width: 138px;
                    }
                    &.item04{
                        width: 118px;
                    }
                }
                &.inner01{
                    transform: translateY(40px);
                }
                &.inner02{
                    transform: translateY(-40px);
                }
                .item-text-wrap{
                    flex-shrink: 0;
                    width: 62%;
                    margin-right: 8px;
                    &.item01{
                        width: 45%;
                    }
                    &.item02{
                        width: 45%;
                    }
                    .item-tit{
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 28px;
                        letter-spacing: -0.02em;
                        color: #4939B1;
                    }
                    .item-desc{
                        margin-top: 8px;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 24px;
                        color: #333333;
                    }
                }
            }
        }
        .sec03-desc{
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #000000;
            margin-top: 60px;
        }
        .sec03-cont-wrap{
            margin-top: 32px;
            padding-bottom: 32px;
            box-sizing: border-box;
            border: 1px solid #E6E6E6;
            border-radius: 20px;
            .sec03-cont-tit{
                text-align: center;
                padding: 32px 0 24px;
                font-weight: 700;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: -0.02em;
                color: #271C7F;
            }
            .sec03-cont-inner{
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                column-gap: 16px;
                row-gap: 40px;
                .list{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    gap: 8px;
                    .img-wrap{
                        width: 124px;
                        height: 124px;
                        box-sizing: border-box;
                        border: 2px solid #DFD9FB;
                        border-radius: 99px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 64px;
                        }
                    }
                    .sec03-item-info{
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 28px;
                        letter-spacing: -0.02em;
                        color: #000000;
                    }
                }
            }
        }
        .sec04-desc{
            margin: 60px 0 32px;
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #000000;
        }
        .sec04-cont-wrap{
            .list-wrap{
                width: 100%;
                display: flex;
                align-items: center;
                gap: 24px;
                .item{
                    width: 20%;
                    height: 260px;
                    border-radius: 20px;
                    overflow: hidden;
                    position: relative;
                    .img-item{
                        width: 100%;
                        height: 100%;
                        img{
                            object-fit: cover;
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .desc-item{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 100%;
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 32px;
                        text-align: center;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .sec05-desc{
            padding: 0 114px;
            margin-top: 40px;
            font-weight: 400;
            font-size: 24px;
            line-height: 38px;
            color: #000000;
        }
        .sec05-cont-wrap{
            height: 410px;
            background: #341DC9;
            border-radius: 205px 0 0 205px;
            width: 100%;
            margin-left: 144px;
            margin-top: 110px;
            display: flex;
            align-items: center;
            .sec05-info-wrap{
                padding: 77px 50px 109px 180px;
                .sec05-info-title{
                    font-weight: 700;
                    font-size: 32px;
                    line-height: 40px;
                    letter-spacing: -0.02em;
                    color: #FFFFFF;
                    margin-bottom: 40px;
                }
                .sec05-info-item{
                    .item-wrap{
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        & + .item-wrap{
                            margin-top: 16px;
                        }
                        .list{
                            box-sizing: border-box;
                            border-radius: 99px;
                            border: 2px solid transparent;
                            background: linear-gradient(#341DC9, #341DC9) padding-box, linear-gradient(45deg, #68DDFB, #fff) border-box;
                            padding: 12px 24px;
                            gap: 10px;
                            width: 340px;
                            height: 64px;
                            display: flex;
                            align-items: center;
                            &.item02{
                                background: linear-gradient(#341DC9, #341DC9) padding-box, linear-gradient(45deg, #B6A2FC, #fff) border-box;
                            }
                            &.item03{
                                background: linear-gradient(#341DC9, #341DC9) padding-box, linear-gradient(45deg, #72A0FF, #fff) border-box;
                            }
                            &.item04{
                                background: linear-gradient(#341DC9, #341DC9) padding-box, linear-gradient(45deg, #65BFFF, #fff) border-box;
                            }
                            .list-icon{
                                width: 40px;
                            }
                            .list-desc{
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 26px;
                                letter-spacing: 0.02em;
                                color: #FFFFFF;
                            }
                        }
                    }
                }
            }
            .sec05-img-wrap{
                position: relative;
                .item-img{
                    width: 600px;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 1;
                }
                .back-item-img{
                    width: 580px;
                    position: absolute;
                    left: 20px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
        .bold{
            font-weight: 700;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 40px 0 0;
        .content-wrap {
            padding: 0 16px;
            &.sec05 {
                .tit {
                    padding: 0 16px;
                }
            }
            &.sec02{
                padding: 0;
                .tit{
                    padding: 0 16px;
                }
            }
            & + .content-wrap {
                margin-top: 80px;
            }
            .tit {
                font-weight: 700;
                font-size: 24px;
                line-height: 36px;
                letter-spacing: -0.02em;
                color: #4939B1;
            }
            .sec01-desc{
                font-weight: 400;
                font-size: 18px;
                line-height: 28px;
                color: #666666;
            }
            .sec01-bg{
                margin-top: 40px;
            }
            .sec02-desc{
                padding: 0 16px;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }
            .sec02-cont{
                margin-top: 40px;
                padding: 32px 16px 32px;
                display: block;
                border-radius: 0;
                .center{
                    margin: 24px 0;
                }
                .sec02-item{
                    width: 100%;
                    &.inner01{
                        transform: translateY(0);
                    }
                    &.inner02{
                        transform: translateY(0);
                    }
                }
            }
            .sec03-desc{
                margin-top: 40px;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }
            .sec03-cont-wrap{
                padding-bottom: 40px;
                .sec03-cont-tit{
                    padding: 32px 0 16px;
                }
                .sec03-cont-inner{
                    padding: 0 20px;
                    grid-template-columns: repeat(2, 1fr);
                    column-gap: 32px;
                    row-gap: 40px;
                    .list{
                        .img-wrap{
                            position: relative;
                            width: 100%;
                            height: auto;
                            border-radius: 50%;
                            &::before {
                                content: "";
                                display: block;
                                padding-top: 100%;
                            }
                            .circle-inner{
                                position: absolute;
                                inset: 0; 
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: 700;
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .sec03-item-info{
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 24px;
                            letter-spacing: -0.02em;
                        }
                    }
                }
            }
            .sec04-desc{
                display: none;
            }
            .sec04-cont-wrap{
                margin-top: 40px;
                .list-wrap{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    gap: 24px;
                    .item{
                        width: 100%;
                        height: 200px;
                        border-radius: 20px;
                    }
                }
            }
            .sec05-desc{
                padding: 0 16px;
                font-weight: 400;
                font-size: 18px;
                line-height: 28px;
            }
            .sec05-cont-wrap{
                height: auto;
                background: #341DC9;
                border-radius: 0;
                margin-left: 0;
                margin-top: 24px;
                display: block;
                position: relative;
                .sec05-info-wrap{
                    padding: 60px 16px 100px;
                    .sec05-info-title{
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: -0.02em;
                    }
                    .sec05-info-item{
                        .item-wrap{
                            display: block;
                            & + .item-wrap{
                                margin-top: 16px;
                            }
                            .list{
                                & + .list{
                                    margin-top: 16px;
                                }
                                width: 100%;
                                .list-desc{
                                    font-weight: 600;
                                    font-size: 16px;
                                    line-height: 20px;
                                    letter-spacing: 0.02em;
                                }
                            }
                        }
                    }
                }
                .sec05-img-wrap{
                    position: absolute;
                    top: -100px;
                    width: 190px;
                    right: 0;
                    .item-img{
                        width: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        transform: translateY(0);
                        z-index: 1;
                    }
                    .back-item-img{
                        width: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        transform: translateY(0);
                    }
                }
            }
        }
    }
`
export default Overview;